export const ACTION_TYPE_PREFIX = 'vbp'
